module.exports = __webpack_public_path__ + "f1eafdc132e887485fa54668b929300e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/les-aliments-bercy/01.jpg
// module id = /LrV
// module chunks = 0